import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';
import { createPortal } from 'react-dom';

interface SessionTimeoutModalProps {
  isOpen: boolean;
  onClose: () => void;
  onRetry: () => void;
  reason: 'refresh_failed' | 'token_expired' | 'session_expired' | 'other_device_login';
}

export function SessionTimeoutModal({
  isOpen,
  onClose,
  // onRetry,
}: SessionTimeoutModalProps) {
  const { i18n } = useTranslation();

  const getModalContent = () => {
    return {
      icon: <AlertTriangle className="w-8 h-8 text-red-600" />,
      title: i18n.language === 'mm' ? 'Session သက်တမ်းကုန်ဆုံးပါပြီ' : 'Session Expired',
      message:
        i18n.language === 'mm'
          ? 'သင့် Session သက်တမ်းကုန်ဆုံးပါပြီ။ ကျေးဇူးပြု၍ ပြန်လည်လော့ဂ်အင်ဝင်ပါ။'
          : 'Your session has expired. Please log in again to continue.',
      buttonText: i18n.language === 'mm' ? 'ပြန်လည်လော့ဂ်အင်ဝင်မည်' : 'Log In Again',
    };
  };

  const content = getModalContent();

  if (!isOpen) return null;

  const dialogContent = (
    <div className="fixed inset-0 z-[100] transition-all duration-300 ease-out will-change-transform transform-gpu">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" />
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="bg-white/95 backdrop-blur-md border border-white/20 shadow-2xl rounded-2xl p-4 sm:p-6 w-full max-w-md mx-4">
          <div className="text-center">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              {content.icon}
            </div>
            <h3 className="text-xl font-semibold mb-2 text-red-600">{content.title}</h3>
            <p className="text-gray-600 mb-6">{content.message}</p>
            <div className="flex space-x-3">
              <button
                onClick={onClose}
                className="flex-1 bg-gray-600 text-white py-3 rounded-xl font-medium hover:bg-gray-700 transition-colors"
              >
                {i18n.language === 'mm' ? 'ပိတ်မည်' : 'Close'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return createPortal(dialogContent, document.body);
}
